import { MatxLoadable } from "matx";
import { authRoles } from "../../auth/authRoles";

const settings = {
  activeLayout: "layout1",
  layout1Settings: {
      topbar: {
          show: false
      },
      leftSidebar: {
          show: false,
          mode: "close"
      }
  },
  layout2Settings: {
      mode: "full",
      topbar: {
          show: false
      },
      navbar: { show: false }
  },
  secondarySidebar: { show: false },
  footer: { show: false }
};

const UserManagement = MatxLoadable({
  loader: () => import("./UserManagement")
})

const UserManagementRoutes = [
  {
    path: "/user_management",
    component: UserManagement,
    auth: authRoles.admin
  }
];

export default UserManagementRoutes;